import { render, staticRenderFns } from "./main.vue?vue&type=template&id=a536ca90&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a536ca90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a536ca90')) {
      api.createRecord('a536ca90', component.options)
    } else {
      api.reload('a536ca90', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=a536ca90&scoped=true", function () {
      api.rerender('a536ca90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DateCustoms/DateNormal/main.vue"
export default component.exports